import React, { useEffect, useState } from "react";
import { Spin, Switch, Table } from "antd";
import CoinStatusIndicator from "../commoncomponent/CoinStatusIndicator";
import PermissionGate from "../commoncomponent/PermissionGate";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import SidebarNav from "../sidebar";
import { Link, useHistory } from "react-router-dom";
import backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import InputLabel from "@mui/material/InputLabel";
import { TextField, Button, Menu, MenuItem, Tooltip } from "@mui/material";
import { HiDotsVertical } from "react-icons/hi";
import {
  addCoin,
  allocateCoinSupply,
  deleteCoin,
  editCoin,
  getCoin,
  getCoinById,
  patchCoinFlags,
  updateCoinStatus,
} from "../../../service/api";
import AllocateCoinSupplyModal from "./AllocateCoinSupplyModal";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import actions from "../../../redux/user/actions";
import { FaArrowLeft } from "react-icons/fa";
import CustomPagination from "../Pagination/pagination";
import FilterPanel from "../commoncomponent/FilterPanel";
import TableToolbar from "../commoncomponent/TableToolbar";
import { useTableSettings } from "../../../hooks/useTableSettings";
import moment from "moment";
import {
  sanitizeInput,
  validateFile,
  validateCoinName,
  validateDescription,
  encryptString,
  decryptString,
} from "../../../config/validation";
import { MdDelete } from "react-icons/md";
import { triggerDownload } from "../../../config/downloadUtils";

const formatDate = (val) => (val ? moment(val).format("DD/MM/YYYY") : "-");

const ALL_COLUMNS = [
  {
    key: "name",
    title: "Coin Name",
    defaultVisible: true,
    render: (r) => r?.name || "-",
  },
  {
    key: "symbol",
    title: "Symbol",
    defaultVisible: true,
    render: (r) => r?.symbol || "-",
  },
  {
    key: "price",
    title: "Price",
    defaultVisible: true,
    render: (r) =>
      r?.price !== undefined && r?.price !== null ? r.price : "-",
  },
  {
    key: "description",
    title: "Description",
    defaultVisible: false,
    render: (r) => r?.description || "-",
  },
  {
    key: "chain_address",
    title: "Chain Address",
    defaultVisible: false,
    render: (r) => r?.chain_address || "-",
  },
  {
    key: "image",
    title: "Coin Image",
    defaultVisible: true,
    render: (r) =>
      r?.image ? (
        <img
          src={r.image}
          alt=""
          draggable="false"
          onContextMenu={(e) => e.preventDefault()}
          style={{ width: "36px", height: "36px", borderRadius: "12px" }}
        />
      ) : (
        "-"
      ),
  },
  {
    key: "createdAt",
    title: "Date",
    defaultVisible: true,
    render: (r) => formatDate(r?.createdAt),
  },
];

const styleDelete = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 290,
  background: "white",
  // border: '1px solid #000',
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
  outline: "none",
};

const Coin = () => {
  const [roleInput, setroleInput] = useState({
    name: "",
    description: "",
    chain_address: "",
    price: "",
    symbol: "",
    image: "",
    depositEnabled: false,
    withdrawEnabled: false,
    maxSupply: "",
    totalSupply: "",
    circulatingSupply: "",
  });
  const [preview, setPreview] = useState("");
  const [logo, setLogo] = useState(false);
  //
  const [roleInputError, setroleInputError] = useState({
    name: "",
    description: "",
    chain_address: false,
    price: false,
    symbol: false,
    image: false,
    maxSupplyError: "",
    totalSupplyError: "",
    circulatingSupplyError: "",
  });
  const [coinList, setCoinList] = useState([]);

  const [user, setUser] = useState(false);
  const [loading, setLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [edit, setEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => setOpenDelete(true);
  const handleCloseDelete = () => setOpenDelete(false);
  const idFromState = useState(false); // To prevent name collision
  const [id, setId] = idFromState;
  const dispatch = useDispatch();
  const history = useHistory();
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");

  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);
  const handleMenuOpen = (event, row) => { setId(row); setAnchorEl(event.currentTarget); };
  const handleMenuClose = () => setAnchorEl(null);

  const [allocateModal, setAllocateModal] = useState({ open: false, coin: null });

  const handleOpenAllocate = (coin) => {
    setAllocateModal({ open: true, coin });
  };

  // single confirmation for deposit/withdraw flag toggles
  const [flagConfirm, setFlagConfirm] = useState(null); // { row, field, checked }
  const [flagLoading, setFlagLoading] = useState(false);

  // double-confirmation state for coin status toggle
  // step1: first confirmation modal  step2: second confirmation modal
  const [statusConfirmStep1, setStatusConfirmStep1] = useState(null); // { row, newStatus }
  const [statusConfirmStep2, setStatusConfirmStep2] = useState(null); // { row, newStatus }
  const [statusLoading, setStatusLoading] = useState(false);

  const {
    pageSize,
    setPageSize,
    pageSizeOptions,
    visibleColumnKeys,
    toggleColumn,
    resetColumns,
    dynamicColumns,
  } = useTableSettings({
    storageKey: "coin-list",
    allColumns: ALL_COLUMNS,
  });

  const roleChange = (e) => {
    if (e.target.type === "file") {
      const file = e.target.files[0];
      const error = validateFile(file);
      if (error) {
        toast.error(error, { toastId: 'coin-fetch-error' });
        e.target.value = null;
        return;
      }

      setroleInput({ ...roleInput, [e.target.name]: file });
      setLogo(true);
      const reader = new FileReader();
      reader.onload = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      const { name, value } = e.target;
      if (e.target.type === "number") {
        if (value >= 0) {
          setroleInput({ ...roleInput, [name]: sanitizeInput(value) });
        }
      } else {
        // For text fields, store raw value and sanitize only on submit
        setroleInput({ ...roleInput, [name]: value });
      }
    }
    setroleInputError({ ...roleInputError, [e.target.name]: "" });
  };

  const getCoinList = () => {
    let body = {
      page: page,
      sizePerPage: pageSize,
      pagination: true,
    };
    if (searchTerm) {
      body.search = searchTerm;
    }

    setLoading(true);
    getCoin(body)
      .then((res) => {
        if (res?.status) {
          setCoinList(res?.data);
        }
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDownload = (format) => {
    const body = { pagination: false };
    if (searchTerm) body.search = searchTerm;
    setDownloadLoading(true);
    getCoin(body)
      .then((res) => {
        const result = res?.data?.result ?? [];
        if (!result.length) { toast.warning("Nothing to download", { toastId: 'nothing-to-download' }); return; }
        const cols = ALL_COLUMNS.filter((c) => visibleColumnKeys.includes(c.key));
        triggerDownload(format, result, cols, "coins");
      })
      .finally(() => setDownloadLoading(false));
  };

  const handleToggleFlag = (row, field, checked) => {
    setFlagConfirm({ row, field, checked });
  };

  const handleFlagConfirm = () => {
    if (!flagConfirm) return;
    const { row, field, checked } = flagConfirm;
    setFlagLoading(true);
    patchCoinFlags(row?._id, { [field]: checked })
      .then((res) => {
        if (!res?.status) throw new Error(res?.message || "Failed");
        toast.success(
          `${field === "depositEnabled" ? "Deposit" : "Withdraw"} ${checked ? "enabled" : "disabled"} for ${row?.symbol || row?.name}`,
          { toastId: 'coin-update-success' }
        );
        getCoinList();
      })
      .catch((err) => {
        toast.error(err?.message || "Update failed", { toastId: 'coin-update-error' });
        getCoinList();
      })
      .finally(() => {
        setFlagLoading(false);
        setFlagConfirm(null);
      });
  };

  const handleStatusToggle = (row, checked) => {
    // Open first confirmation step
    setStatusConfirmStep1({ row, newStatus: checked ? 1 : 0 });
  };

  const handleStatusStep1Confirm = () => {
    setStatusConfirmStep2(statusConfirmStep1);
    setStatusConfirmStep1(null);
  };

  const handleStatusStep2Confirm = () => {
    if (!statusConfirmStep2) return;
    const { row, newStatus } = statusConfirmStep2;
    setStatusLoading(true);
    updateCoinStatus(row?._id, newStatus)
      .then((res) => {
        if (!res?.status) throw new Error(res?.message || "Failed");
        toast.success(`${row?.symbol || row?.name} ${newStatus === 1 ? "activated" : "deactivated"} successfully`, { toastId: 'coin-status-success' });
        getCoinList();
      })
      .catch((err) => {
        toast.error(err?.message || "Status update failed", { toastId: 'coin-status-error' });
      })
      .finally(() => {
        setStatusLoading(false);
        setStatusConfirmStep2(null);
      });
  };

  const handleClear = () => {
    setroleInput({
      ...roleInput,
      name: "",
      description: "",
      chain_address: "",
      symbol: "",
      price: "",
      image: "",
      depositEnabled: false,
      withdrawEnabled: false,
      maxSupply: "",
      totalSupply: "",
      circulatingSupply: "",
    });
    setroleInputError({
      name: "",
      description: "",
      chain_address: false,
      symbol: false,
      price: false,
      image: false,
      maxSupplyError: "",
      totalSupplyError: "",
      circulatingSupplyError: "",
    });
  };
  // ADD USER FUNCTION
  const addUserFun = async () => {
    let hasError = false;
    let errors = {
      name: "",
      description: "",
      chain_address: false,
      price: false,
      symbol: false,
      image: false,
      maxSupplyError: "",
      totalSupplyError: "",
      circulatingSupplyError: "",
    };

    // Validate coin name using validation function
    const nameError = validateCoinName(roleInput?.name);
    if (nameError) {
      errors.name = nameError;
      hasError = true;
    }

    // Validate description (optional but if provided should be valid)
    const descriptionError = validateDescription(roleInput?.description, {
      minLength: 10,
      maxLength: 500,
      fieldName: "Description",
      required: false,
    });
    if (descriptionError) {
      errors.description = descriptionError;
      hasError = true;
    }

    // Validate other required fields
    if (!roleInput?.price) {
      errors.price = true;
      hasError = true;
    }
    if (!roleInput?.chain_address) {
      errors.chain_address = true;
      hasError = true;
    }
    if (!roleInput?.symbol) {
      errors.symbol = true;
      hasError = true;
    }
    if (!roleInput?.image) {
      errors.image = true;
      hasError = true;
    }

    const max = roleInput.maxSupply !== "" ? Number(roleInput.maxSupply) : null;
    const total = roleInput.totalSupply !== "" ? Number(roleInput.totalSupply) : null;
    if (max !== null && total !== null && total > max) {
      errors.totalSupplyError = `Total Supply cannot exceed Max Supply (${max.toLocaleString()})`;
      hasError = true;
    }

    if (hasError) {
      setroleInputError(errors);
      return;
    }
    if (roleInput) {
      setLoading(true);
      if (!edit) {
        const plainData = {
          chain_address: sanitizeInput(roleInput?.chain_address),
          description: sanitizeInput(roleInput?.description),
          name: sanitizeInput(roleInput?.name),
          price: roleInput?.price,
          symbol: sanitizeInput(roleInput?.symbol),
          depositEnabled: !!roleInput?.depositEnabled,
          withdrawEnabled: !!roleInput?.withdrawEnabled,
          ...(roleInput?.maxSupply !== "" && { maxSupply: Number(roleInput.maxSupply) }),
          ...(roleInput?.totalSupply !== "" && { totalSupply: Number(roleInput.totalSupply) }),
        };

        const encryptedData = await decryptString(plainData);

        const formData = new FormData();
        formData.append("image", roleInput?.image);
        formData.append("encrypt", encryptedData);

        addCoin(formData)
          .then((res) => {
            if (res?.status) {
              toast.success(res?.message, { toastId: 'coin-add-success' });
              setUser(false);
              getCoinList();
              handleClear();
            } else {
              toast.error(res?.message, { toastId: 'coin-add-error' });
            }
          })
          .catch((err) => {
            toast.error(err?.response?.data?.message, { toastId: 'coin-add-error' });
          })
          .finally((res) => {
            setLoading(false);
          });
      } else {
        // Create plain object with text fields to encrypt
        const plainData = {
          chain_address: sanitizeInput(roleInput?.chain_address),
          description: sanitizeInput(roleInput?.description),
          price: roleInput?.price,
          name: sanitizeInput(roleInput?.name),
          symbol: sanitizeInput(roleInput?.symbol),
          ...(roleInput?.maxSupply !== "" && { maxSupply: Number(roleInput.maxSupply) }),
          ...(roleInput?.totalSupply !== "" && { totalSupply: Number(roleInput.totalSupply) }),
        };

        // Encrypt the plain object
        const encryptedData = await decryptString(plainData);

        // Create FormData with image and encrypted data
        const formData = new FormData();
        if (roleInput?.image?.type) {
          formData.append("image", roleInput?.image);
        }
        formData.append("encrypt", encryptedData);

        editCoin(id?._id, formData)
          .then((res) => {
            if (res?.status) {
              toast.success(res?.message, { toastId: 'coin-edit-success' });
              setEdit(false);
              setUser(false);
              getCoinList();
              handleClear();
            } else {
              toast.error(res?.message, { toastId: 'coin-edit-error' });
            }
          })
          .catch((err) => {
            toast.error(err?.response?.data?.message, { toastId: 'coin-edit-error' });
          })
          .finally((res) => {
            setLoading(false);
          });
      }
    }
  };
  // DELETE USER FUNCTION

  const handleDeleteFunction = () => {
    setLoading(true);
    deleteCoin(id?._id)
      .then((res) => {
        if (res?.status) {
          toast.success(res?.message, { toastId: 'coin-delete-success' });
          handleCloseDelete();
          getCoinList();
          setId(null);
        } else {
          toast.error(res?.message, { toastId: 'coin-delete-error' });
        }
      })
      .catch((e) => {
        setLoading(false);
        toast.error(e?.response?.data?.message, { toastId: 'coin-delete-error' });
      })
      .finally((res) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getCoinList();
  }, [page, pageSize, searchTerm]);

  // Reset to page 1 whenever filters or page size change.
  useEffect(() => {
    setPage(1);
  }, [pageSize, searchTerm]);

  const getCoinDataById = (id) => {
    getCoinById(id)
      ?.then((res) => {
        if (res?.status) {
          let data = res?.data;
          setroleInput({
            ...roleInput,
            chain_address: data?.chain_address,
            symbol: data?.symbol,
            image: data?.image,
            price: data?.price,
            description: data?.description,
            name: data?.name,
            depositEnabled: !!data?.depositEnabled,
            withdrawEnabled: !!data?.withdrawEnabled,
            maxSupply: data?.maxSupply ?? "",
            totalSupply: data?.totalSupply ?? "",
            circulatingSupply: data?.circulatingSupply ?? "",
          });
          if (data?.image) {
            setLogo(true);
          }
        }
      })
      .catch((e) => {});
  };

  const depositColumn = {
    key: "depositEnabled",
    title: "Deposit",
    render: (_, row) => (
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <CoinStatusIndicator
          coin={row}
          networks={row?.networks || []}
          flow="deposit"
        />
        <PermissionGate module="coin" action="update">
          <Switch
            size="small"
            checked={!!row?.depositEnabled}
            onChange={(checked) =>
              handleToggleFlag(row, "depositEnabled", checked)
            }
          />
        </PermissionGate>
      </div>
    ),
  };

  const withdrawColumn = {
    key: "withdrawEnabled",
    title: "Withdraw",
    render: (_, row) => (
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <CoinStatusIndicator
          coin={row}
          networks={row?.networks || []}
          flow="withdraw"
        />
        <PermissionGate module="coin" action="update">
          <Switch
            size="small"
            checked={!!row?.withdrawEnabled}
            onChange={(checked) =>
              handleToggleFlag(row, "withdrawEnabled", checked)
            }
          />
        </PermissionGate>
      </div>
    ),
  };

  const actionColumn = {
    key: "__action",
    title: "Action",
    className: "text-end",
    render: (_, row) => (
      <div className="text-end">
        <Button
          onClick={(e) => handleMenuOpen(e, row)}
          style={{ minWidth: 0, padding: 6 }}
        >
          <HiDotsVertical size={18} />
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={menuOpen && id?._id === row?._id}
          onClose={handleMenuClose}
          PaperProps={{
            elevation: 4,
            sx: { borderRadius: 2, mt: 1, boxShadow: "0px 4px 16px rgba(0,0,0,0.1)", minWidth: 170 },
          }}
        >
          <MenuItem
            onClick={() => {
              handleMenuClose();
              history.push(`/admin/coin-detail/${row?._id}`);
            }}
            sx={{ fontSize: 14 }}
          >
            View Details
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleMenuClose();
              setId(row);
              setLogo(false);
              setPreview("");
              handleClear();
              setUser(true);
              setEdit(true);
              getCoinDataById(row?._id);
            }}
            sx={{ fontSize: 14 }}
          >
            Edit
          </MenuItem>
          {row?.totalSupply > 0 && (
            <Tooltip
              title={row?.isSupplyAllocated ? "Supply already allocated" : ""}
              placement="left"
              disableHoverListener={!row?.isSupplyAllocated}
            >
              <span>
                <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    handleOpenAllocate(row);
                  }}
                  disabled={!!row?.isSupplyAllocated}
                  sx={{ fontSize: 14, color: row?.isSupplyAllocated ? undefined : "#0369a1" }}
                >
                  Allocate Supply
                </MenuItem>
              </span>
            </Tooltip>
          )}
          <MenuItem
            onClick={() => {
              handleMenuClose();
              handleOpenDelete();
            }}
            sx={{ fontSize: 14, color: "#dc2626" }}
          >
            Delete
          </MenuItem>
        </Menu>
      </div>
    ),
  };

  const statusColumn = {
    key: "status",
    title: "Status",
    render: (_, row) => (
      <PermissionGate module="coin" action="update">
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Switch
            size="small"
            checked={row?.status === 1}
            onChange={(checked) => handleStatusToggle(row, checked)}
          />
          <span style={{ fontSize: 12, color: row?.status === 1 ? "#26af48" : "#e63c3c", fontWeight: 500 }}>
            {row?.status === 1 ? "Active" : "Inactive"}
          </span>
        </div>
      </PermissionGate>
    ),
  };

  const columns2 = [...dynamicColumns, statusColumn, depositColumn, withdrawColumn, actionColumn];

  return (
    <>
      <SidebarNav />
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-7 col-aut0">
                <h3 className="page-title">Coin</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Coin</li>
                </ul>
              </div>
              {!user && (
                <div className="col-sm-5 col">
                  <a
                    onClick={() => {
                      handleClear(),
                        setEdit(false),
                        setUser(true),
                        setLogo(false);
                    }}
                    data-bs-toggle="modal"
                    className="coin-add-btn float-end mt-2"
                  >
                    <i className="fe fe-plus" /> Add Coin
                  </a>
                </div>
              )}
            </div>
          </div>

          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              {user ? (
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0px",
                      gap: "10px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                      }}
                    >
                      <FaArrowLeft
                        style={{
                          marginTop: "3px",
                          cursor: "pointer",
                          width: "30px",
                          height: "20px",
                        }}
                        onClick={() => {
                          setEdit(false), setUser(false);
                        }}
                      />
                      <h4>{edit ? "Edit Coin" : "Add Coin"}</h4>
                    </div>{" "}
                    <div
                      style={{
                        // borderTop: "1px solid grey",
                        height: "56px",
                        display: "flex",
                        justifyContent: "end",
                        // marginTop: "30px",
                      }}
                    >
                      <button
                        className="btn btn-primary"
                        onClick={addUserFun}
                        disabled={loading}
                        style={{ marginBottom: "10px", marginTop: "9px" }}
                      >
                        {loading ? (
                          <Spinner size="sm" />
                        ) : edit ? (
                          "Update"
                        ) : (
                          "Add"
                        )}
                      </button>
                    </div>
                  </div>
                  <div style={{ margin: "10px" }} className="page-grid">
                    <div>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginLeft: "7px" }}
                      >
                        Coin Name &nbsp;
                        {roleInputError?.name && (
                          <small style={{ color: "red" }}>
                            {roleInputError?.name}
                          </small>
                        )}
                      </InputLabel>
                      <TextField
                        variant="outlined"
                        style={{
                          // width: "370px",
                          marginLeft: "5px",
                          height: "100%",
                        }}
                        className="form-control"
                        type="text"
                        placeholder="Bitcoin"
                        value={roleInput?.name}
                        onChange={roleChange}
                        name="name"
                        id="name"
                        error={!!roleInputError?.name}
                      />
                    </div>
                    <div>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginLeft: "7px" }}
                      >
                        Price &nbsp;
                        {roleInputError?.price && (
                          <small style={{ color: "red" }}>
                            {"Price is required"}
                          </small>
                        )}
                      </InputLabel>
                      <TextField
                        variant="outlined"
                        style={{
                          // width: "370px",
                          marginLeft: "5px",
                          height: "100%",
                        }}
                        className="form-control"
                        type="number"
                        placeholder="price"
                        value={roleInput?.price}
                        onChange={roleChange}
                        name="price"
                        id="price"
                        inputProps={{ min: 0 }}
                        onKeyDown={(e) => {
                          if (e.key === "-" || e.key === "e" || e.key === "E") {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                    <div>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginLeft: "7px" }}
                      >
                        Description &nbsp;
                        {roleInputError?.description && (
                          <small style={{ color: "red" }}>
                            {roleInputError?.description}
                          </small>
                        )}
                      </InputLabel>
                      <TextField
                        variant="outlined"
                        style={{
                          // width: "370px",
                          marginLeft: "5px",
                          height: "100%",
                        }}
                        className="form-control"
                        type="text"
                        placeholder="Coin Description"
                        value={roleInput?.description}
                        onChange={roleChange}
                        name="description"
                        id="description"
                        error={!!roleInputError?.description}
                        multiline
                        rows={3}
                      />
                    </div>
                    <div>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginLeft: "7px" }}
                      >
                        Chain Address &nbsp;
                        {roleInputError?.chain_address && (
                          <small style={{ color: "red" }}>
                            {"Chain Address is required"}
                          </small>
                        )}
                      </InputLabel>
                      <TextField
                        variant="outlined"
                        style={{
                          // width: "370px",
                          marginLeft: "5px",
                          height: "100%",
                        }}
                        className="form-control"
                        type="tecxt"
                        placeholder="Chain Address"
                        value={roleInput?.chain_address}
                        onChange={roleChange}
                        name="chain_address"
                        id="chain_address"
                      />
                    </div>

                    <div>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginLeft: "7px" }}
                      >
                        Coin Symbol &nbsp;
                        {roleInputError?.symbol && (
                          <small style={{ color: "red" }}>
                            {"Coin Symbol is required"}
                          </small>
                        )}
                      </InputLabel>
                      <TextField
                        variant="outlined"
                        style={{
                          // width: "370px",
                          marginLeft: "5px",
                          height: "100%",
                        }}
                        className="form-control"
                        type="text"
                        placeholder="Coin Symbol"
                        value={roleInput?.symbol}
                        onChange={roleChange}
                        name="symbol"
                        id="symbol"
                      />
                    </div>
                    {/* Token Supply Settings */}
                    <div style={{ marginLeft: "7px", marginTop: 14 }}>
                      <div style={{ padding: "12px 14px", background: "#f0f6ff", borderRadius: 6, border: "1px solid #c6dcf7" }}>
                          <div style={{ fontSize: 12, color: "#3b6fd4", marginBottom: 10, fontWeight: 500 }}>Token Supply <span style={{ fontWeight: 400, opacity: 0.7 }}>(optional — for internally issued tokens)</span></div>
                          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                            <div style={{ flex: 1, minWidth: 140 }}>
                              <InputLabel style={{ fontSize: 12, display: "flex", alignItems: "center", gap: 4 }}>
                                Max Supply
                                <Tooltip title="Hard cap — the maximum number of tokens that can ever exist. Total Supply can never exceed this. Example: if Max Supply is 1,000,000, no more than 1,000,000 tokens will ever be created." arrow placement="top">
                                  <span style={{ cursor: "help", color: "#888", fontSize: 13, lineHeight: 1 }}>ⓘ</span>
                                </Tooltip>
                              </InputLabel>
                              <TextField
                                variant="outlined"
                                size="small"
                                fullWidth
                                type="number"
                                inputProps={{ min: 0 }}
                                placeholder="e.g. 1000000"
                                value={roleInput?.maxSupply}
                                error={!!roleInputError?.maxSupplyError}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  setroleInput({ ...roleInput, maxSupply: val });
                                  const newMax = val !== "" ? Number(val) : null;
                                  const newTotalErr = newMax !== null && roleInput.totalSupply !== "" && Number(roleInput.totalSupply) > newMax
                                    ? `Total Supply cannot exceed Max Supply (${newMax.toLocaleString()})`
                                    : "";
                                  setroleInputError(prev => ({ ...prev, maxSupplyError: "", totalSupplyError: newTotalErr }));
                                }}
                                name="maxSupply"
                              />
                              {roleInputError?.maxSupplyError && <div style={{ fontSize: 11, color: "#dc2626", marginTop: 2 }}>{roleInputError.maxSupplyError}</div>}
                            </div>
                            <div style={{ flex: 1, minWidth: 140 }}>
                              <InputLabel style={{ fontSize: 12, display: "flex", alignItems: "center", gap: 4 }}>
                                Total Supply
                                <Tooltip title="The amount that will be credited to the user's Funding Wallet when you click 'Allocate Supply'. This also becomes the Circulating Supply after allocation. Must be ≤ Max Supply." arrow placement="top">
                                  <span style={{ cursor: "help", color: "#888", fontSize: 13, lineHeight: 1 }}>ⓘ</span>
                                </Tooltip>
                              </InputLabel>
                              <TextField
                                variant="outlined"
                                size="small"
                                fullWidth
                                type="number"
                                inputProps={{ min: 0 }}
                                placeholder="e.g. 1000000"
                                value={roleInput?.totalSupply}
                                error={!!roleInputError?.totalSupplyError}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  setroleInput({ ...roleInput, totalSupply: val });
                                  const newTotal = val !== "" ? Number(val) : null;
                                  const max = roleInput.maxSupply !== "" ? Number(roleInput.maxSupply) : null;
                                  const circ = roleInput.circulatingSupply !== "" ? Number(roleInput.circulatingSupply) : null;
                                  const totalErr = max !== null && newTotal !== null && newTotal > max
                                    ? `Cannot exceed Max Supply (${max.toLocaleString()})`
                                    : "";
                                  const circErr = newTotal !== null && circ !== null && circ > newTotal
                                    ? `Cannot exceed Total Supply (${newTotal.toLocaleString()})`
                                    : "";
                                  setroleInputError(prev => ({ ...prev, totalSupplyError: totalErr, circulatingSupplyError: circErr }));
                                }}
                                name="totalSupply"
                              />
                              {roleInputError?.totalSupplyError && <div style={{ fontSize: 11, color: "#dc2626", marginTop: 2 }}>{roleInputError.totalSupplyError}</div>}
                            </div>
                            {edit && (
                              <div style={{ flex: 1, minWidth: 140 }}>
                                <InputLabel style={{ fontSize: 12, display: "flex", alignItems: "center", gap: 4 }}>
                                  Circulating Supply
                                  <Tooltip title="Automatically set to Total Supply when 'Allocate Supply' is performed. Read-only — cannot be edited manually." arrow placement="top">
                                    <span style={{ cursor: "help", color: "#888", fontSize: 13, lineHeight: 1 }}>ⓘ</span>
                                  </Tooltip>
                                </InputLabel>
                                <div style={{ padding: "8px 10px", background: "#fff", border: "1px solid #ddd", borderRadius: 4, fontSize: 14 }}>
                                  {roleInput?.circulatingSupply !== "" ? Number(roleInput.circulatingSupply).toLocaleString() : "0"}
                                  <div style={{ fontSize: 11, color: "#888", marginTop: 2 }}>Set by Allocate Supply action</div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                    <div style={{ marginLeft: "7px", marginTop: 12 }}>
                      <InputLabel style={{ marginBottom: 4 }}>
                        Deposit / Withdraw (master switches)
                      </InputLabel>
                      <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
                        <label style={{ display: "flex", alignItems: "center", gap: 6 }}>
                          <Switch
                            size="small"
                            checked={!!roleInput?.depositEnabled}
                            onChange={(checked) =>
                              setroleInput({ ...roleInput, depositEnabled: checked })
                            }
                          />
                          Deposits enabled
                        </label>
                        <label style={{ display: "flex", alignItems: "center", gap: 6 }}>
                          <Switch
                            size="small"
                            checked={!!roleInput?.withdrawEnabled}
                            onChange={(checked) =>
                              setroleInput({ ...roleInput, withdrawEnabled: checked })
                            }
                          />
                          Withdrawals enabled
                        </label>
                      </div>
                      <div style={{ fontSize: 11, opacity: 0.6, marginTop: 4 }}>
                        Kill switches — off here disables the coin across all chains.
                      </div>
                    </div>
                    <div>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginLeft: "7px" }}
                      >
                        Coin Image &nbsp;
                      </InputLabel>

                      {!logo ? (
                        <TextField
                          variant="outlined"
                          style={{
                            // width: "370px",
                            marginLeft: "5px",
                            height: "100%",
                          }}
                          className="form-control"
                          type="file"
                          inputProps={{
                            accept:
                              "image/jpeg,image/png,image/gif,image/bmp,image/webp",
                          }}
                          placeholder="File upload"
                          onChange={roleChange}
                          name="image"
                          id="image"
                        />
                      ) : (
                        <div className="img-incoming-div">
                          <img
                            src={preview ? preview : roleInput?.image}
                            alt=""
                            draggable="false"
                            onContextMenu={(e) => e.preventDefault()}
                            className="img-incoming"
                          />
                          <MdDelete
                            onClick={() => {
                              setLogo(false);
                              setroleInput({ ...roleInput, image: "" });
                              setPreview("");
                            }}
                            className={`img-incoming-icon display-flex`}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="list-layout">
                  <div className="list-layout__main">
                    <div className="card">
                      <div className="card-body">
                        <TableToolbar
                          pageSize={pageSize}
                          setPageSize={setPageSize}
                          pageSizeOptions={pageSizeOptions}
                          total={coinList?.total}
                          page={page}
                          visibleColumnKeys={visibleColumnKeys}
                          allColumns={ALL_COLUMNS}
                          toggleColumn={toggleColumn}
                          resetColumns={resetColumns}
                          onDownload={handleDownload}
                          downloadLoading={downloadLoading}
                        />
                        <div className="table-responsive">
                          {loading ? (
                            <div className="his-spin">
                              <Spin
                                size="large"
                                style={{ position: "relative", top: "35%" }}
                              />
                            </div>
                          ) : (
                            <Table
                              pagination={false}
                              style={{ overflowX: "auto" }}
                              columns={columns2}
                              dataSource={coinList ? coinList?.result : []}
                              rowKey={(record) => record._id || record.id}
                            />
                          )}
                          {coinList && coinList?.total > pageSize && (
                            <CustomPagination
                              key={`pg-${pageSize}`}
                              totalTabs={coinList?.total}
                              tabsPerPage={pageSize}
                              handleChange={setPage}
                              className={`${
                                loading ? "display-hide" : "display-flex"
                              }`}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="list-layout__filters">
                    <FilterPanel
                      count={coinList?.total}
                      onClear={() => {
                        setSearchTerm("");
                      }}
                    >
                      <FilterPanel.Field label="Search">
                        <input
                          type="text"
                          placeholder="Coin name or symbol"
                          value={searchTerm}
                          onChange={(e) =>
                            setSearchTerm(sanitizeInput(e.target.value))
                          }
                        />
                      </FilterPanel.Field>
                    </FilterPanel>
                  </div>
                </div>
              )}
            </div>
          </div>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openDelete}
            onClose={handleCloseDelete}
            closeAfterTransition
            slots={{ backdrop: backdrop }}
            slotProps={{
              backdrop: {
                timeout: 500,
              },
            }}
          >
            <Fade in={openDelete}>
              <Box style={styleDelete}>
                <div style={{ margin: "10px", textAlign: "center" }}>
                  Please confirm before deleting
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <button
                    className="btn btn-danger"
                    disabled={loading}
                    onClick={handleDeleteFunction}
                    style={{ marginBottom: "10px", marginTop: "15px" }}
                  >
                    {loading ? <Spinner size="sm" /> : "Delete"}
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={handleCloseDelete}
                    style={{
                      marginLeft: "7px",
                      marginBottom: "10px",
                      marginTop: "15px",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </Box>
            </Fade>
          </Modal>

          {/* ── Deposit / Withdraw flag: single confirmation ── */}
          <Modal
            open={!!flagConfirm}
            onClose={() => !flagLoading && setFlagConfirm(null)}
            closeAfterTransition
            slots={{ backdrop: backdrop }}
            slotProps={{ backdrop: { timeout: 500 } }}
          >
            <Fade in={!!flagConfirm}>
              <Box style={styleDelete}>
                <div style={{ padding: "16px 10px 6px", textAlign: "center" }}>
                  <div style={{ fontSize: 18, marginBottom: 8 }}>
                    {flagConfirm?.checked ? "✅" : "⛔"}
                  </div>
                  <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 8 }}>
                    {flagConfirm?.checked ? "Enable" : "Disable"}{" "}
                    {flagConfirm?.field === "depositEnabled" ? "Deposit" : "Withdraw"}?
                  </div>
                  <div style={{ fontSize: 13, color: "#595959" }}>
                    This will{" "}
                    <strong>{flagConfirm?.checked ? "enable" : "disable"}</strong>{" "}
                    <strong>{flagConfirm?.field === "depositEnabled" ? "deposits" : "withdrawals"}</strong>{" "}
                    for <strong>{flagConfirm?.row?.symbol || flagConfirm?.row?.name}</strong>.
                  </div>
                </div>
                <div style={{ display: "flex", justifyContent: "center", gap: 8, padding: "12px 10px 16px" }}>
                  <button
                    className={`btn ${flagConfirm?.checked ? "btn-success" : "btn-danger"}`}
                    disabled={flagLoading}
                    onClick={handleFlagConfirm}
                    style={{ minWidth: 100 }}
                  >
                    {flagLoading ? <Spinner size="sm" /> : "Confirm"}
                  </button>
                  <button
                    className="btn btn-outline-secondary"
                    disabled={flagLoading}
                    onClick={() => setFlagConfirm(null)}
                    style={{ minWidth: 80 }}
                  >
                    Cancel
                  </button>
                </div>
              </Box>
            </Fade>
          </Modal>

          {/* ── Status toggle: Step 1 confirmation ── */}
          <Modal
            open={!!statusConfirmStep1}
            onClose={() => setStatusConfirmStep1(null)}
            closeAfterTransition
            slots={{ backdrop: backdrop }}
            slotProps={{ backdrop: { timeout: 500 } }}
          >
            <Fade in={!!statusConfirmStep1}>
              <Box style={styleDelete}>
                <div style={{ padding: "16px 10px 6px", textAlign: "center" }}>
                  <div style={{ fontSize: 18, marginBottom: 8 }}>
                    {statusConfirmStep1?.newStatus === 1 ? "⚡" : "🔴"}
                  </div>
                  <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 8 }}>
                    {statusConfirmStep1?.newStatus === 1 ? "Activate Coin?" : "Deactivate Coin?"}
                  </div>
                  <div style={{ fontSize: 13, color: "#595959", marginBottom: 4 }}>
                    You are about to{" "}
                    <strong>{statusConfirmStep1?.newStatus === 1 ? "activate" : "deactivate"}</strong>{" "}
                    <strong>{statusConfirmStep1?.row?.symbol || statusConfirmStep1?.row?.name}</strong>.
                  </div>
                  <div style={{ fontSize: 12, color: "#8c8c8c" }}>
                    This will affect trading availability for all users.
                  </div>
                </div>
                <div style={{ display: "flex", justifyContent: "center", gap: 8, padding: "12px 10px 16px" }}>
                  <button
                    className={`btn ${statusConfirmStep1?.newStatus === 1 ? "btn-success" : "btn-warning"}`}
                    onClick={handleStatusStep1Confirm}
                    style={{ minWidth: 100 }}
                  >
                    Proceed
                  </button>
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => setStatusConfirmStep1(null)}
                    style={{ minWidth: 80 }}
                  >
                    Cancel
                  </button>
                </div>
              </Box>
            </Fade>
          </Modal>

          {/* ── Status toggle: Step 2 confirmation ── */}
          <Modal
            open={!!statusConfirmStep2}
            onClose={() => !statusLoading && setStatusConfirmStep2(null)}
            closeAfterTransition
            slots={{ backdrop: backdrop }}
            slotProps={{ backdrop: { timeout: 500 } }}
          >
            <Fade in={!!statusConfirmStep2}>
              <Box style={styleDelete}>
                <div style={{ padding: "16px 10px 6px", textAlign: "center" }}>
                  <div style={{ fontSize: 18, marginBottom: 8 }}>⚠️</div>
                  <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 8 }}>
                    Final Confirmation
                  </div>
                  <div style={{ fontSize: 13, color: "#595959", marginBottom: 4 }}>
                    Are you absolutely sure you want to{" "}
                    <strong style={{ color: statusConfirmStep2?.newStatus === 1 ? "#26af48" : "#e63c3c" }}>
                      {statusConfirmStep2?.newStatus === 1 ? "ACTIVATE" : "DEACTIVATE"}
                    </strong>{" "}
                    <strong>{statusConfirmStep2?.row?.symbol || statusConfirmStep2?.row?.name}</strong>?
                  </div>
                  <div style={{ fontSize: 12, color: "#8c8c8c" }}>
                    This cannot be undone without another confirmation.
                  </div>
                </div>
                <div style={{ display: "flex", justifyContent: "center", gap: 8, padding: "12px 10px 16px" }}>
                  <button
                    className={`btn ${statusConfirmStep2?.newStatus === 1 ? "btn-success" : "btn-danger"}`}
                    disabled={statusLoading}
                    onClick={handleStatusStep2Confirm}
                    style={{ minWidth: 120 }}
                  >
                    {statusLoading ? (
                      <Spinner size="sm" />
                    ) : statusConfirmStep2?.newStatus === 1 ? (
                      "Yes, Activate"
                    ) : (
                      "Yes, Deactivate"
                    )}
                  </button>
                  <button
                    className="btn btn-outline-secondary"
                    disabled={statusLoading}
                    onClick={() => setStatusConfirmStep2(null)}
                    style={{ minWidth: 80 }}
                  >
                    Cancel
                  </button>
                </div>
              </Box>
            </Fade>
          </Modal>
        </div>
      </div>

      <AllocateCoinSupplyModal
        isOpen={allocateModal.open}
        coin={allocateModal.coin}
        onClose={() => setAllocateModal({ open: false, coin: null })}
        onSuccess={() => getCoinList()}
      />
    </>
  );
};

export default Coin;
